/* eslint-disable react/jsx-closing-bracket-location */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Box, Inline } from '../LayoutPrimitives';

export default function DotPagination({
    itemCount,
    activeIndex = 0,
    onClick
}) {
    const dots = [];

    for (let i = 0; i < itemCount; i += 1) {
        dots.push(
            <li key={i}>
                <button
                    data-sarsa-dot-pag-dot
                    className={cx({ 'active': i === activeIndex })}
                    onClick={() => onClick(i)}
                >
                    <span className="rec-sr-only">{`Photo ${i + 1}`}</span>
                    {i === activeIndex && (
                        <span className="rec-sr-only">(Current item)</span>
                    )}
                </button>
            </li>
        );
    }

    return (
        <div data-component="DotPagination">
            <Box alignX="center" alignY="center">
                <Inline space="xs" noWrap shouldRenderInnerContainer={false}>
                    <ul aria-label="Slide show navigation">
                        {dots}
                    </ul>
                </Inline>
            </Box>
        </div>
    );
}

DotPagination.propTypes = {
    itemCount: PropTypes.number.isRequired,
    activeIndex: PropTypes.number,
    onClick: PropTypes.func
};
